import { setCookie, destroyCookie, getCookie } from 'utils/cookies';

import SETTINGS from '../settings';

const COOKIES_COUNTRIES = [
  'AD',
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GI',
  'GR',
  'HU',
  'HR',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'MT',
  'NO',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'SM',
  'VA',
];

const AllowCookies = {
  isConfirmationRequired: countryCode => {
    return COOKIES_COUNTRIES.indexOf(countryCode.toUpperCase()) >= 0;
  },

  get: (ctx = null) => {
    const value = getCookie(ctx, SETTINGS.COOKIE_ALLOW_COOKIES_NAME);
    return value === 'true' || value === true;
  },

  set: (allow = true, ctx = null) => {
    setCookie(
      ctx,
      SETTINGS.COOKIE_ALLOW_COOKIES_NAME,
      allow,
      SETTINGS.COOKIE_ALLOW_COOKIES_OPTIONS,
    );
  },

  destroy: (ctx = null) => {
    destroyCookie(ctx, SETTINGS.COOKIE_ALLOW_COOKIES_NAME);
  },
};

export default AllowCookies;
